<script>
export default {
  methods: {
    // 时间戳转时间工具
    getTime (timestamp) {
      let n = parseInt(timestamp)
      let date = new Date(n) // 获取一个时间对象

      let Y = date.getFullYear() + '-' // 获取完整的年份(4位,1970)
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-' // 获取月份(0-11,0代表1月,用的时候记得加上1)
      let D = date.getDate() + '  ' // 获取日(1-31)
      let h = date.getHours() + ':' // 获取小时数(0-23)
      let m = date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes() // 获取分钟数(0-59)
      // let s = date.getSeconds() // 获取秒数(0-59)
      return Y + M + D + h + m
    },
    /**
     * @description 解析身份证信息
     * @param {String | Number} idCard - 身份证号
     * @param {Number} analyseType - 解析类型（birthDate-出生日期 sex-性别 age-年龄）
     * @return {String}
     */
    getAnalysisIdCard (idCard = '', analyseType = 'birthDate') {
      const analyseTypeArr = ['birthDate', 'sex', 'age']
      if (idCard === '') {
        throw new Error('传入身份证不能为空！')
      }
      if (typeof idCard !== 'string') {
        idCard += ''
      }
      if (!analyseTypeArr.includes(analyseType)) {
        throw new Error('请传入正确的解析类型！')
      }
      if (idCard !== '' && !this.validIdCard(idCard)) {
        throw new Error('传入身份证格式有误!')
      }
      const analyseObj = {
        'birthDate': (idCard) => {
          // 获取出生日期
          const birth = `${idCard.substring(6, 10)}-${idCard.substring(10, 12)}-${idCard.substring(12, 14)}`
          return birth
        },
        'sex': (idCard) => {
          // 获取性别
          const sex = parseInt(idCard.substr(16, 1)) % 2 === 1 ? '男' : '女'
          return sex
        },
        'age': (idCard) => {
          // 获取年龄(计算周岁，未过今年的生日则不加上一岁)
          const myDate = new Date()
          const month = myDate.getMonth() + 1
          const day = myDate.getDate()
          let age = myDate.getFullYear() - idCard.substring(6, 10) - 1
          // eslint-disable-next-line no-mixed-operators
          if (idCard.substring(10, 12) < month || idCard.substring(10, 12) === month && idCard.substring(12, 14) <= day) {
            age++
          }
          return age
        }
      }
      return analyseObj[analyseType](idCard)
    },
    // 身份证正则验证
    validIdCard (str) {
      const reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      return reg.test(str)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/util/JsUtill.vue